import { ReactElement, ReactNode } from "react"
interface Props {
  children: ReactNode
}

export function Layout({ children }: Props): ReactElement {
  return <div style={{ paddingTop: 160 }}>{children}</div>
}
